import PropTypes from 'prop-types';
import React, {
  useState, useRef,
  useImperativeHandle,
  forwardRef,
} from 'react';
import CustomKeyboard from '@components/common/CustomKeyboardCopy/indexRevamp';

const InputKeyboard = forwardRef(({
  maxLength,
  name,
  onChange,
  selectedInput,
  btnStyle,
  // amount,
}, ref) => {
  const keyboardRef = useRef(null);
  const [keyboardOpen, setKeyboardOpen] = useState(true);
  const [typed, setTyped] = useState('');
  const [inputs] = useState('');

  const closeKeyboard = () => {
    setKeyboardOpen(false);
  };

  const onClickBtn = (e) => {
    setTyped(e === '{bksp}' ? { ...typed, [selectedInput]: typed[selectedInput]?.slice(0, -1) } : { ...typed, [selectedInput]: typed[selectedInput] ? typed[selectedInput].concat(e) : ''.concat(e) });
    onChange(e === '{bksp}' ? inputs.slice(0, -1) : inputs.concat(e));
  };
  useImperativeHandle(
    ref,
    () => ({
      setKeyboardValue: (val) => {
        if (keyboardRef.current) {
          keyboardRef.current.setInput(val, name);
        }
      },
      openKeyboard: () => setKeyboardOpen(true)
    }),
    []
  );
  return (
    <>
      {keyboardOpen && (
        <CustomKeyboard
          onClickBtn={(e) => onClickBtn(e)}
          type="numericWithBin"
          typed={typed[name] || ''}
          customClass="px-1"
          closeKeyboard={closeKeyboard}
          maxLength={maxLength}
          cashIn={true}
          screenType={btnStyle}
        />
      )}
    </>
  );
});

InputKeyboard.displayName = 'InputKeyboard';

InputKeyboard.propTypes = {
  maxLength: PropTypes.number,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  selectedInput: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
};

export default InputKeyboard;
